import { render, staticRenderFns } from "./staffInfo.vue?vue&type=template&id=641fdd80"
import script from "./staffInfo.vue?vue&type=script&lang=js"
export * from "./staffInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641fdd80')) {
      api.createRecord('641fdd80', component.options)
    } else {
      api.reload('641fdd80', component.options)
    }
    module.hot.accept("./staffInfo.vue?vue&type=template&id=641fdd80", function () {
      api.rerender('641fdd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffCustomerManage/staffInfo.vue"
export default component.exports